// 判断浏览器是否处于全屏状态 （需要考虑兼容问题）
export function statusFull(){
    // 火狐浏览器
    let isFull = document.mozFullScreen ||
    document.fullScreen ||
    // 谷歌浏览器及Webkit内核浏览器
    document.webkitIsFullScreen ||
    document.webkitRequestFullScreen ||
    document.mozRequestFullScreen ||
    document.msFullscreenEnabled

  if (isFull === undefined) {
    isFull = false
  }
  return isFull
}

// 全屏
export function openFullscreen(isFullFlag) {
    const screenTime = document.getElementById('screenTime');
    /* 获取)元素以全屏显示页面 */
    if(isFullFlag){
        screenTime.style.display = 'block'
        const full = document.getElementById('imgView')
        if (full.RequestFullScreen) {
            full.RequestFullScreen()
            //兼容Firefox
        } else if (full.mozRequestFullScreen) {
            full.mozRequestFullScreen()
            //兼容Chrome, Safari and Opera等
        } else if (full.webkitRequestFullScreen) {
            full.webkitRequestFullScreen()
            //兼容IE/Edge
        } else if (full.msRequestFullscreen) {
            full.msRequestFullscreen()
        }
    } else {
        screenTime.style.display = 'none'
        if(document.exitFullScreen) {
            document.exitFullScreen();
        //兼容Firefox
        } else if(document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        //兼容Chrome, Safari and Opera等
        
        } else if(document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        //兼容IE/Edge
        } else if(document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }
}

// 云图预加载
export function preloadImage(sourceData) {
  const waiting = document.getElementById("waiting");
  let promiseList = [];
  const preload = document.getElementById("preloadImg");
  if(preload !== null) {
    preload.innerHTML = "";
    for(let i = 0; i < sourceData.length; i++){
      let img = ''
      const imgUrl = sourceData[i].list[0].url
      const newPromise = new Promise((resolve, reject) => {
        img = new Image()
        img.src = imgUrl
        img.onload = () => resolve("success")
        img.onerror = () => new Error(imgUrl + ' load error')
      })
      promiseList.push(newPromise)
      preload.appendChild(img)
    }

    /* 等所有图片加载完毕则移除等待动画 */
    Promise.all(promiseList).then((res) => {
      waiting.style.display = "none";
    }).catch((e)=>{
      console.log(e);
    });
  }
}
// export function preloadImage(sourceData) {
//   const waiting = document.getElementById("waiting");
//   // const waitingTxt = document.getElementById("loading");
//   let promiseList = [];
//   const preload = document.getElementById("preloadImg");
//   if(preload !== null) {
//     preload.innerHTML = "";
//     sourceData.map((item) => {
//       let img = ''
//       const imgUrl = item.list[0].url
//       const newPromise = new Promise((resolve, reject) => {
//         img = new Image()
//         // 先绑定image.onload事件，后加载图片。如果图片从缓存中加载，速度非常快以至于没来得及绑定事件就加载完毕，自然不会触发绑定事件。
//         img.onload = () => resolve("success")
//         img.src = imgUrl
//         // img.onload = () => resolve(imgUrl);
//         img.onerror = () => reject(new Error(imgUrl + ' load error'));
//       })
//       promiseList.push(newPromise)
//       preload.appendChild(img)
//     })

//     /* 等所有图片加载完毕则移除等待动画 */
//     Promise.all(promiseList).then((res) => {
//       waiting.style.display = "none";
//       // waitingTxt.style.display = "none"
//     }).catch((e)=>{
//       console.log(e);
//     });
//   }
// }

// 预加载图片
export function preloadImg(sourceData) {
    const waiting = document.getElementById("waiting");
    const waitingTxt = document.getElementById("loading");
    let promiseList = [];
    const preload = document.getElementById("preloadImg");
    preload.innerHTML = "";

    sourceData.map((item) => {
        let img = ''
        const imgUrl = item.url
        const newPromise = new Promise((resolve, reject) => {
            img = new Image()
            img.src = imgUrl
            img.onload = () => resolve("success")
            // img.onload = () => resolve(imgUrl);
            img.onerror = () => reject(new Error(imgUrl + ' load error'));
            img.onabort = ()=> {}
        })
        promiseList.push(newPromise)
        preload.appendChild(img)
    })
    
    /* 等所有图片加载完毕则移除等待动画 */
    Promise.all(promiseList).then((res) => {
        // console.log('load all success', res)
        waiting.style.display = "none";
        waitingTxt.style.display = "none"
    }).catch((e)=>{
        console.log(e);
    });

    /* 最后等待时间 30s 已过则移除等待动画 */
    // setTimeout(() => {
    //     waiting.style.display = "none";
    //     waitingTxt.style.display = "none"
    // }, 40000);
}

// 获取地址栏
export function UrlSearch() {
    var name,value; 
    var str = location.href; //取得整个地址栏
    var num = str.indexOf("?") 
    str = str.substr(num+1); //取得所有参数   stringvar.substr(start [, length ]

    var arr = str.split("&"); //各个参数放到数组里
    for(var i = 0; i < arr.length; i++){ 
        num = arr[i].indexOf("="); 
        if(num > 0){ 
            name = arr[i].substring(0,num);
            value = arr[i].substr(num+1);
            this[name] = value;
        }
    } 
} 


export function imgScaling (imgWidth, imgHeight, containerWidth, containerHeight) {
    let [
      // 用于设定图片的宽和高
      tempWidth,
      tempHeight,
    ] = [
      undefined,
      undefined
    ]
    try {
      imgWidth = parseFloat(imgWidth)
      imgHeight = parseFloat(imgHeight)
      containerWidth = parseFloat(containerWidth)
      containerHeight = parseFloat(containerHeight)
    } catch (error) {
      throw new Error('抱歉，我只接收数值类型或者可以转成数值类型的参数')
    }
  
    if (imgWidth > 0 && imgHeight > 0) {
      //原图片宽高比例 大于 指定的宽高比例，这就说明了原图片的宽度必然 > 高度
      if (imgWidth / imgHeight >= containerWidth / containerHeight) {
        if (imgWidth > containerWidth) {
          // alert('aaaaaaaa')
          tempWidth = containerWidth
          // 按原图片的比例进行缩放
          tempHeight = (imgHeight * containerWidth) / imgWidth
        } else {
          // 按照图片的大小进行缩放
          tempWidth = imgWidth
          tempHeight = imgHeight
        }
      } else {  // 原图片的高度必然 > 宽度
        if (imgHeight > containerHeight) {
  
          tempHeight = containerHeight
          // 按原图片的比例进行缩放
          tempWidth = (imgWidth * containerHeight) / imgHeight
        } else {
          // 按原图片的大小进行缩放
          tempWidth = imgWidth
          tempHeight = imgHeight
        }
      }
    }
  
    return { tempWidth,  tempHeight}
}



//m,n为正整数的分子和分母
// export function reductionTo(m, n) {
//   var arr = [];
//   if (!this.isInteger(m) || !this.isInteger(n)) {
//       console.log('m和n必须为整数');
//       return;
//   } else if (m<=0||n <= 0) {
//       console.log('m和n必须大于0');
//       return;
//   }
//   var a = m;
//   var b = n;
//   (a >= b) ? (a = m, b = n) : (a = n, b = m);
//   if (m != 1 && n != 1) {
//       for (var i = b; i >= 2; i--) {
//           if (m % i == 0 && n % i == 0) {
//               m = m / i;
//               n = n / i;
//           }
//       }
//   }
//   arr[0] = m;
//   arr[1] = n;
//   return arr;
// }

// //判断一个数是否为整数
// isInteger(obj) {
//   return obj % 1 === 0
// }

//有序预加载
// export function PreLoad.prototype._ordered () {
//   var opts = this.opts,
//     imgs = this.imgs,
//     len = imgs.length,
//     count = 0;

//   load();
//   function load() {
//     var imgObj = new Image();

//     $(imgObj).on('load error', function () {
//       //相当于if(opts.each){ opts.each(); } ，如果有配置each()方法则调用，后面的all()同理
//       opts.each && opts.each(count);

//       if (count >= len) {
//         //所有图片加载完毕
//         opts.all && opts.all();
//       } else {
//         //如果没加载完，继续调用自身加载下一张
//         load();
//       }
//       count++;
//     });

//     imgObj.src = imgs[count];//缓存图片
//   }
// }

// px动态转换rem
export function pxToRem(px, rootValue = 100) {
  return `${px / rootValue}rem`;
}